import React from 'react';
import { Grid, styled, Skeleton, useTheme, Divider } from '@mui/material';
import { RoundedSkeleton } from '../../ClientTable/LoadingSkeleton';

export const StyledSkeleton = styled(Skeleton)(({ width, height }) => ({
  animation: 'wave',
  width,
  height,
  background: 'linear-gradient(175deg, #92CFCD -9.81%, #336E6B 96.32%)',
}));

function ActivitiesLoading() {
  const theme = useTheme();
  const Item = styled(Grid)(() => ({
    backgroundColor: '#fff',
    padding: theme.spacing(3),
    boxShadow: theme.borderStyles.cardBorders,
    borderRadius: '10px',
    gap: theme.spacing(4),
  }));

  return (
    <Grid gap={2} display="flex" flexDirection="column" mt={6}>
      <Grid display="flex" justifyContent="space-between">
        <Grid gap="12px" display="flex" flexDirection="row" alignItems="center">
          <RoundedSkeleton variant="rounded" width={136} height={14.875} />
          <StyledSkeleton variant="rounded" width={72} height={24} />
        </Grid>
        <Grid gap={7} display="flex" flexDirection="row" alignItems="center">
          <RoundedSkeleton variant="rounded" width={79} height={14} />
          <RoundedSkeleton variant="rounded" width={30} height={20} />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ActivitiesLoading;
